import React, { Fragment } from 'react';
import { translate } from 'react-i18next';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import PropTypes from 'prop-types';
import { FTTitle } from '../Fuse';
import FuseButton from '../FuseControls/FuseButton';
import BrowserPopUp from '../BrowserPopUp/BrowserPopUp';
import LoaderBar from '../Loaders/LoaderBar';
import Icon from '../Icon/Icon';
import BrowserStore from '../../browser/stores/BrowserStore';
import FileEventController from '../../browser/FileEventController';

import './FileProcessingNotification.css';

const block = b.lock('FileProcessingNotification');

function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

class FileProcessingNotification extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        browser: BrowserStore.PropType.isRequired
    };

    // We should always have a file url, at least for new policies. Adding the extra check just in case of old policies,
    // which are unlikely to be tested as thoroughly
    maybeRenderFileUrl = (data) => (data.fileUrl ? <Fragment>
        <div className={block('Label')}>URL Source</div>
        <div className={block('FileUrl', { dataUrl: data.fileUrl.startsWith('data:') })}>{data.fileUrl}</div>
    </Fragment> : null)

    renderPopUpBody = () => {
        const { t, browser } = this.props;
        const { fileManagerStore, frameEl } = browser;
        return fileManagerStore.fileProcessingDataArr.map((fileEvent) => (
            <FileEventController
                key={fileEvent.id}
                fileEvent={fileEvent}
                render={(data) => {
                    return <Fragment>
                        <FTTitle>{data.notificationTitle}</FTTitle>
                        <div className={block('FileEventBody')}>
                            <div className={block('Label')}>Date</div>
                            <div className={block('Value')}>{data.startTime}</div>
                            <div className={block('Label')}>File Name</div>
                            <div className={block('Value')}>{fileEvent.name}</div>
                            {this.maybeRenderFileUrl(data)}
                            {data.categories && <Fragment>
                                <div className={block('Label')}>Category</div>
                                <div className={block('Value')}>{data.categories.join(', ')}</div>
                            </Fragment>}
                            {data.fileMimeType && <Fragment>
                                <div className={block('Label')}>File Type</div>
                                <div className={block('Value')}>{data.fileMimeType}</div>
                            </Fragment>}
                            {data.country && <Fragment>
                                <div className={block('Label')}>Source Country</div>
                                <div className={block('Value')}>{data.country}</div>
                            </Fragment>}
                            {data.fileSize > 0 && <Fragment>
                                <div className={block('Label')}>File Size</div>
                                <div className={block('Value')}>{formatBytes(data.fileSize)}</div>
                            </Fragment>}

                            <div className={block('FileStatus')}>
                                {data.isScanning ?
                                    <div className={block('FileProgressWrapper')}>
                                        <LoaderBar className={block('FileLoaderWrapperStyle')}/>
                                        <Icon
                                            className={block('FileCancelProgress')}
                                            type={'cancel'}
                                            onClick={() => fileManagerStore.cancelFileProcessing(frameEl, fileEvent.id)}
                                        />
                                    </div> : null
                                }
                            </div>
                            <div className={block('FileStatusText', { type: data.notificationType })}>
                                {data.notificationStatus}
                            </div>
                        </div>
                        {data.filePreview ? <div className={block('InfoBottomSection')}>
                            <div className={block('InfoBottomTextContainer')}>
                                <span className={block('InfoBottomText')}>
                                    {t('Notification.FILE_PROCESSING.preview.message')}
                                </span>
                            </div>

                            <FuseButton
                                type={'primary'}
                                color={'blue'}
                                className={block('SingleActionButton')}
                                onClick={() => {
                                    window.top.open(data.filePreview);
                                    browser.closeNotification();
                                }}
                            >{t('Notification.FILE_PROCESSING.preview.action')}</FuseButton>
                        </div> : null}
                    </Fragment>;
                }}
            />
        ));
    };
    render() {
        const { browser } = this.props;
        const notification = browser.notification;
        const isOpen = !!(notification && notification === BrowserStore.NOTIFICATION.FILE_PROCESSING);
        if (!isOpen) return null;
        return <BrowserPopUp
            isOpen={isOpen}
            shouldCloseOnOverlayClick
            shouldCloseOnEsc
            onRequestClose={() => browser.closeNotification()}
            onClose={() => browser.closeNotification()}
            bodyClassName={block('Wrapper')}
        >
            {this.renderPopUpBody()}
        </BrowserPopUp>;
    }
}

export default translate()(inject('browser', 'snack')(observer(FileProcessingNotification)));
